import appBackupSchedule from "../../views/appRoutes/backupSchedule.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("backupschedule", {
    url: "backupschedule/:id",
    parent: "app",
    views: {
      view: {
        template: appBackupSchedule,
      },
    },
    reloadOnSearch: false,
    data: { title: "Backup Schedule" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/backupSchedule/backupSchedule.urls.js